import React from 'react';
import { 
  Users, 
  Target,
  Calendar
} from 'lucide-react';

const Jan19StatusReport = () => {
  return (
    <div className="status-report">
      <div className="report-header">
        <h1 className="report-title">
          <Calendar className="w-8 h-8 text-blue-600" />
          AI Team Status Report
        </h1>
        <div className="report-meta">
          <span className="meta-item">
            <Calendar className="w-4 h-4" />
            January 19, 2025
          </span>
          <span className="meta-item">
            <Target className="w-4 h-4" />
            Status Update
          </span>
        </div>
      </div>

      <div className="report-grid">
        {/* Updates Since Last Report */}
        <div className="report-section">
          <h2 className="section-title">
            <Target className="w-6 h-6 text-teal-600" />
            Updates Since Last Report
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>
                  <Users className="w-5 h-5 inline mr-2 text-indigo-600" />
                  Team Updates
                </h3>
                <span className="status-badge in-progress">ACTIVE</span>
              </div>
              <ul className="achievement-list">
                <li>One team member left</li>
                <li>Three interns have joined full time</li>
                <li>Two interns are joining this week</li>
                <li>We are wanting to hire a mid-senior level python engineer to control, manage and build more robust server stack</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Product Updates</h3>
                <span className="status-badge completed">DEPLOYED</span>
              </div>
              <ul className="achievement-list">
                <li>Identified a bug, tested and deployed today. We are now able to extract from non-standard COIs.</li>
                <li>Kinetic development for iteration 2 is complete and in QA</li>
                <li>We have started work on offloading logs, debug logs and documents to Azure Storage. This will be completed this week and deployed next week.</li>
                <li>We are PostHog ready.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Next Two Weeks */}
        <div className="report-section">
          <h2 className="section-title">
            <Calendar className="w-6 h-6 text-blue-600" />
            Next Two Weeks
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Upcoming Initiatives</h3>
                <span className="status-badge scheduled">PLANNED</span>
              </div>
              <ul className="achievement-list">
                <li>Created an internal tool to review debug logs for easier management. Making it 10x faster to figure out Root cause.</li>
                <li>POC to use RunPod as GPU back bone. Main objective is to hit our OKR to reduce cost and get some performance gains</li>
                <li>Caching system across all products.</li>
                <li>Have a report for OKR status in our next meeting</li>
                <li>Cost reporting once a month</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="report-footer">
        <p><strong>Prepared by:</strong> Naqi & Claude</p>
        <p><strong>Report Date:</strong> January 19, 2025</p>
        <p><strong>Period:</strong> Updates Since Last Report</p>
      </div>
    </div>
  );
};

export default Jan19StatusReport;
